import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./social-share.m.css";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import LinkedIn from "../../atoms/social-media-icons/LinkedIn";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const list = [
    {
      Type: (
        <div styleName="icon-wrapper facebook-bg">
          <Facebook height="8px" width="8px" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.facebook ? socials.facebook.url : socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: (
        <div styleName="icon-wrapper linkedin-bg">
          <LinkedIn height="8px" width="8px" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.linkedin ? socials.linkedin.url : socialLinks["linkedin-url"],
      name: "Linkedin"
    },
    {
      Type: (
        <div styleName="icon-wrapper twitter-bg">
          <Twitter height="8px" width="8px" isShareRequired={false} />
        </div>
      ),
      url: socials && socials.twitter ? socials.twitter.url : socialLinks["twitter-url"],
      name: "Twitter"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list.map(({ url, Type, name }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(SocialShareIcons);
